import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import Divider from '@material-ui/core/Divider';
import { Link } from 'react-router-dom';

const ApprovalConfirmDialog = ({ open, onClose, onApprove, payrollRun }) => {
  const isReviewed = payrollRun.status === 'Reviewed' || payrollRun.status ==='ReadyForApproval';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Approve Payroll</DialogTitle>
      <DialogContent>
        {!isReviewed ? (
          <>
            <Typography gutterBottom color="error">
              Warning: This payroll has not been reviewed yet.
            </Typography>
            <Typography gutterBottom>
              Are you sure you want to approve this payroll without review?
            </Typography>
          </>
        ) : (
          <>
            <Typography gutterBottom>
              Current Status: <strong>{payrollRun.status}</strong>
            </Typography>
            <Typography variant="subtitle1" style={{ marginTop: 16, marginBottom: 8 }}>
              Review Remarks:
            </Typography>
            {payrollRun.remarks && payrollRun.remarks.length > 0 ? (
              payrollRun.remarks.map((remark, index) => (
                <React.Fragment key={index}>
                  <Grid container direction="column" spacing={1}>
                    <Grid item>
                      <Typography><strong>Reviewer:</strong> {remark.user}</Typography>
                    </Grid>
                    <Grid item>
                      <Typography><strong>Date:</strong> {moment(remark.date).format('YYYY-MM-DD HH:mm')}</Typography>
                    </Grid>
                    <Grid item>
                      <Typography><strong>Remark:</strong> {remark.remarkText}</Typography>
                    </Grid>
                  </Grid>
                  {index < payrollRun.remarks.length - 1 && <Divider style={{ margin: '8px 0' }} />}
                </React.Fragment>
              ))
            ) : (
              <Typography>No remarks available.</Typography>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        {!isReviewed && (
          <Button 
            component={Link} 
            to={`/reports/payroll/${payrollRun.id}/summery`} 
            color="primary"
          >
            Review Payroll
          </Button>
        )}
        <Button onClick={onApprove} color="primary" variant="contained">
          Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalConfirmDialog; 